import { render } from "./CompetitionsMain.vue?vue&type=template&id=718f9ecd&scoped=true"
import script from "./CompetitionsMain.vue?vue&type=script&lang=js"
export * from "./CompetitionsMain.vue?vue&type=script&lang=js"

import "./CompetitionsMain.vue?vue&type=style&index=0&id=718f9ecd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718f9ecd"]])

export default __exports__